
import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useEffect } from "react";
import DatePicker from "react-datepicker";
import { IMaterial } from "../../../models/materials";
import { editMaterial, RootState, saveMaterial } from "../../../redux";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getSizes } from "../../../redux/slices/sizes";
import '../../../themes/styles.css';

interface Props {
    onCancel: () => void,
    material: IMaterial,
    editing: boolean
}

export const MyForm = ({ onCancel, material, editing }: Props) => {
    const dispatch = useAppDispatch();

    const { sizes = [] } = useAppSelector((state: RootState) => state.sizes);
    console.log(sizes);
    useEffect(() => {
        dispatch(getSizes() as any);
    }, [dispatch])

    const onSave = (material: IMaterial) => {
        editing ? dispatch(editMaterial(material) as any) : dispatch(saveMaterial(material) as any);
    }

    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h3">
                Materials - Available Quantity: {material.availableQuantity}
            </Typography>
            <br />
            <Divider />
            <Formik
                initialValues={material}
                onSubmit={(values) => {
                    onSave(values as any);
                    onCancel();
                }}
            // validationSchema={Yup.object({
            //     name: Yup.string()
            //         .max(15, 'Debe de tener 15 caracteres o menos')
            //         .required('Requerido'),
            // }) } 
            >

                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="isbn">Isbn</Typography>
                                <Field name="isbn" type="text" />
                                <ErrorMessage name="isbn" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="name">Name</Typography>
                                <Field name="name" type="text" />
                                <ErrorMessage name="name" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="isbn10">Isbn 10</Typography>
                                <Field name="isbn10" type="text" />
                                <ErrorMessage name="isbn10" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="author">Author</Typography>
                                <Field name="author" type="text" />
                                <ErrorMessage name="author" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="edition">Edition</Typography>
                                <Field name="edition" type="text" />
                                <ErrorMessage name="edition" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="publisher">Publisher</Typography>
                                <Field name="publisher" type="text" />
                                <ErrorMessage name="publisher" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="discountId">Discount Id</Typography>
                                <Field name="discountId" type="text" />
                                <ErrorMessage name="discountId" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="weight">Weight</Typography>
                                <Field name="weight" type="text" />
                                <ErrorMessage name="weight" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="length">Length</Typography>
                                <Field name="length" type="text" />
                                <ErrorMessage name="length" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="width">Width</Typography>
                                <Field name="width" type="text" />
                                <ErrorMessage name="width" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="type">Top Size</Typography>
                                <Field component="select" name="topSizeId" placeholder="Select a Top Size">
                                    <option value="">
                                        Select a Top Size
                                    </option>
                                    {
                                        sizes.map((size) =>
                                            <option key={size.id} value={size.id}>{size.name}</option>
                                        )
                                    }
                                </Field>
                                <ErrorMessage name="type" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="type">Bottom Size</Typography>
                                <Field component="select" name="bottomSizeId" placeholder="Select a Bottom Size">
                                    <option value="">
                                        Select a Bottom Size
                                    </option>
                                    {
                                        sizes.map((size) =>
                                            <option key={size.id} value={size.id}>{size.name}</option>
                                        )
                                    }
                                </Field>
                                <ErrorMessage name="type" component="span" className="error-message" />
                                <br />
                            </Grid>


                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="custom">Custom</Typography>
                                <Field name="custom" type="checkbox" />
                                <ErrorMessage name="custom" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="nationalIsbn">National ISBN</Typography>
                                <Field name="nationalIsbn" type="text" />
                                <ErrorMessage name="nationalIsbn" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="startDate">Start Date</Typography>
                                <DatePicker
                                    selected={(formik.values.startDate && new Date(formik.values.startDate)) || null}
                                    dateFormat="MMMM d, yyyy"
                                    className="form-control"
                                    name="startDate"
                                    onChange={(date: any) => formik.setFieldValue('startDate', date)}
                                />
                                <ErrorMessage name="startDate" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="endDate">End Date</Typography>
                                <DatePicker
                                    selected={(formik.values.endDate && new Date(formik.values.endDate)) || null}
                                    dateFormat="MMMM d, yyyy"
                                    className="form-control"
                                    name="endDate"
                                    onChange={(date: any) => formik.setFieldValue('endDate', date)}
                                />
                                <ErrorMessage name="endDate" component="span" className="error-message" />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="copyright">Copyright</Typography>
                                <Field name="copyright" type="text" />
                                <ErrorMessage name="copyright" component="span" className="error-message" />
                                <br />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )
                }
            </Formik>
        </Grid >
    )
}

